import ToggleColorMode from './ToggleColorMode';

export default ToggleColorMode;
